module.exports = __webpack_public_path__ + "img/arrcouvAllTerm.ffd5ed9f.png";